'use client';
import React, { useState, useEffect, useRef } from 'react';

interface NavItem {
  label: string;
  href: string;
  submenu?: {label: string;href: string;}[];
}

const navItems: NavItem[] = [
{
  label: 'Accueil',
  href: '#',
  submenu: [
  { label: 'Accueil Principal', href: '#' },
  { label: 'À Propos', href: '#' },
  { label: 'Nos Services', href: '#' },
  { label: 'Notre Équipe', href: '#' },
  { label: 'Contact', href: '#' }]
},
{ label: 'À Propos', href: '#' },
{ label: 'Services', href: '#' },
{
  label: 'Pages',
  href: '#',
  submenu: [
  { label: 'Médecine Générale', href: '#' },
  { label: 'Médecine Spécialisée', href: '#' },
  { label: 'Télémédecine', href: '#' },
  { label: 'Notre Équipe', href: '#' },
  { label: 'Analyses Biomédicales', href: '#' },
  { label: 'Évacuation Sanitaire', href: '#' },
  { label: 'Témoignages', href: '#' },
  { label: 'FAQ', href: '#' }]
},
{ label: 'Contact', href: '#' }];


export default function Header() {
  const [isSticky, setIsSticky] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openMobileSubmenu, setOpenMobileSubmenu] = useState<string | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className="main-header">
      <div className={`header-sticky${isSticky ? ' active' : ''}`}>
        <nav className="navbar">
          <div className="dentaire-container" style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            {/* Logo */}
            <a href="#" className="navbar-brand" style={{ display: 'flex', alignItems: 'center' }}>
              <img
                src="/assets/images/logo-cosa.png"
                alt="COSA – Compagnie de Santé Africaine"
                style={{ height: 52, width: 'auto', maxWidth: 180, objectFit: 'contain', display: 'block' }}
              />
            </a>

            {/* Desktop Menu */}
            <div className="navbar-collapse main-menu" style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div className="nav-menu-wrapper">
                <ul>
                  {navItems.map((item) =>
                  <li key={item.label} className={item.submenu ? 'submenu' : ''}>
                      <a href={item.href}>{item.label}</a>
                      {item.submenu &&
                    <ul className="sub-menu">
                          {item.submenu.map((sub) =>
                      <li key={sub.label} className="nav-item">
                              <a href={sub.href}>{sub.label}</a>
                            </li>
                      )}
                        </ul>
                    }
                    </li>
                  )}
                </ul>
              </div>
              <div className="header-btn d-inline-flex">
                <a href="#" className="btn-default">prendre rendez-vous</a>
              </div>
            </div>

            {/* Mobile Toggle */}
            <div className="navbar-toggle" style={{ display: 'none' }}>
              <button
                onClick={() => setMobileOpen(!mobileOpen)}
                style={{
                  background: 'var(--primary-color)',
                  padding: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '38px',
                  height: '38px',
                  borderRadius: '8px',
                  border: 'none',
                  cursor: 'pointer'
                }}>
                
                <span style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <span style={{ display: 'block', width: '22px', height: '3px', background: '#fff', borderRadius: '6px' }}></span>
                  <span style={{ display: 'block', width: '22px', height: '3px', background: '#fff', borderRadius: '6px' }}></span>
                  <span style={{ display: 'block', width: '22px', height: '3px', background: '#fff', borderRadius: '6px' }}></span>
                </span>
              </button>
            </div>
          </div>
        </nav>

        {/* Mobile Menu */}
        {mobileOpen &&
        <div className="responsive-menu" style={{ background: 'var(--primary-color)', position: 'absolute', width: '100%', zIndex: 200 }}>
            <ul style={{ listStyle: 'none', margin: '5px 0', padding: 0 }}>
              {navItems.map((item) =>
            <li key={item.label}>
                  <div
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 20px', cursor: 'pointer' }}
                onClick={() => item.submenu && setOpenMobileSubmenu(openMobileSubmenu === item.label ? null : item.label)}>
                
                    <a href={item.href} style={{ color: '#fff', fontSize: '16px', fontWeight: 500, textTransform: 'capitalize' }}>{item.label}</a>
                    {item.submenu &&
                <span style={{ color: '#fff', fontSize: '12px' }}>{openMobileSubmenu === item.label ? '▼' : '►'}</span>
                }
                  </div>
                  {item.submenu && openMobileSubmenu === item.label &&
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                      {item.submenu.map((sub) =>
                <li key={sub.label}>
                          <a href={sub.href} style={{ display: 'block', padding: '10px 20px 10px 30px', color: '#fff', fontSize: '15px', transition: 'all 0.3s' }}>{sub.label}</a>
                        </li>
                )}
                    </ul>
              }
                </li>
            )}
              <li>
                <a href="#" style={{ display: 'block', padding: '10px 20px', color: 'var(--accent-color)', fontSize: '16px', fontWeight: 500, textTransform: 'capitalize' }}>prendre rendez-vous</a>
              </li>
            </ul>
          </div>
        }
      </div>

      <style>{`
        @media (max-width: 991px) {
          .navbar-collapse { display: none !important; }
          .navbar-toggle { display: block !important; }
        }
      `}</style>
    </header>);

}